import type { CategorySection as CategorySectionType } from '@ria-client/supergraph/roundup/types';
import { CategorySection } from './financial-advisors-roundup-sections/category-section';

export interface FinancialAdvisorsRoundupSectionsProps {
  categorySections?: CategorySectionType[];
}

export function FinancialAdvisorsRoundupSections({
  props,
}: {
  props: FinancialAdvisorsRoundupSectionsProps;
}): React.JSX.Element | null {
  const { categorySections } = props;

  if (!categorySections?.length) return null;

  return (
    <ul className="mb-8 list-none p-0">
      {categorySections.map((section, index) => {
        const productPositionBase = categorySections
          .slice(0, index + 1)
          .reduce((position, currentSection) => position + currentSection.productCards.length, -1);

        return (
          <CategorySection
            key={`${section.title ?? 'section'}-${index}`}
            productPositionBase={productPositionBase}
            section={section}
          />
        );
      })}
    </ul>
  );
}
